import { Alert, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NoAccessWarning = () => {
  return (
    <Alert color="warning">
      <Text.Normal weight="normal" size="300">
        {i18n.t('bookkeepers.companies.bookkeeper.no_access')}
      </Text.Normal>
    </Alert>
  )
}

export default NoAccessWarning
